var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud_svg__clip0_3399_26850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 11.23c0 2.08-1.712 3.768-3.825 3.77H3.795C1.684 14.984-.016 13.285 0 11.202.015 9.21 1.6 7.574 3.616 7.465c-.012-2.384 1.941-4.327 4.36-4.338.438 0 .874.06 1.292.186C10.725.382 14.317-.83 17.29.605a5.954 5.954 0 0 1 2.505 2.27c1.95-.086 3.604 1.404 3.691 3.326.02.427-.04.854-.177 1.26 2.058.075 3.688 1.74 3.691 3.769Z",
    fill: "#1D352A",
    fillOpacity: 0.5
  }))));
};
export default SvgCloud;